/** Prestito marketplace a periodi (card Legend / allenatore). */
export const isPeriodMarketplaceLoan = (loan) =>
  loan?.loan_kind === 'period' ||
  loan?.loanKind === 'period' ||
  (loan?.period_count != null && Number(loan.period_count) > 0) ||
  (loan?.periodCount != null && Number(loan.periodCount) > 0);

/** Periodi già occupati (DB + periodo attualmente in corso). */
export const getPeriodsUsedDisplay = (loan) => {
  const usedDb = Number(loan?.periods_used ?? loan?.periodsUsed) || 0;
  const inUse =
    loan?.status === 'active' ||
    loan?.borrower_id != null ||
    loan?.borrowerId != null;
  return usedDb + (inUse ? 1 : 0);
};

export const getLoanAcceptPrice = (loan) => {
  if (isPeriodMarketplaceLoan(loan)) {
    return parseFloat(loan.price_per_period) || parseFloat(loan.total_price) || 0;
  }
  return parseFloat(loan.total_price) || 0;
};

export const getLoanCardTitle = (loan) =>
  loan?.customName ||
  loan?.custom_name ||
  loan?.player?.full_name ||
  `Card #${loan?.sample_card_id ?? loan?.card_id ?? '?'}`;

export const getLoanPeriodHours = (loan) => Number(loan?.period_hours) || 6;

export const getLoanPeriodsTotal = (loan) => {
  if (loan?.period_slots_total != null) {
    return Number(loan.period_slots_total);
  }
  return Number(loan?.period_count ?? loan?.periodCount) || 0;
};

export const getLoanPeriodsRemaining = (loan) => {
  if (loan?.period_slots_remaining != null) {
    return Number(loan.period_slots_remaining);
  }
  const total = getLoanPeriodsTotal(loan);
  return Math.max(0, total - getPeriodsUsedDisplay(loan));
};

export const getLoanPeriodsUsedDisplay = (loan) => {
  if (loan?.periods_used_aggregate != null) {
    return Number(loan.periods_used_aggregate);
  }
  return getPeriodsUsedDisplay(loan);
};

/** Rimuovi listing: prestiti a periodi solo se nessun periodo è mai stato preso. */
export const canCancelListedLoan = (loan) => {
  if (!isPeriodMarketplaceLoan(loan)) {
    return true;
  }
  if (getPeriodsUsedDisplay(loan) > 0) {
    return false;
  }
  if (loan?.last_period_borrower_id != null || loan?.lastPeriodBorrowerId != null) {
    return false;
  }
  return true;
};

/** Modifica prezzo prossimi periodi: solo tra un periodo e l'altro (status listed). */
export const canUpdatePeriodLoanPrice = (loan) => {
  if (!isPeriodMarketplaceLoan(loan)) {
    return false;
  }
  const status = loan?.status || 'listed';
  if (status !== 'listed') {
    return false;
  }
  return getLoanPeriodsRemaining(loan) > 0;
};
